import { render } from "./BiometricLogin.vue?vue&type=template&id=6c2ba7e8"
import script from "./BiometricLogin.vue?vue&type=script&lang=js"
export * from "./BiometricLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__